module.exports = new __parcel__URL__("edit-ticket-with-background-dark.9447b0b7.svg").toString();